module.exports = __webpack_public_path__ + "img/join.431cee00.png";